<div class="flex flex-col items-center gap-6">
  <form class="flex items-center gap-4" [formGroup]="formGroup">
    <input
      [formControl]="formGroup.controls.isYearlyCycle"
      tuiSwitch
      type="checkbox"
    />
    <span class="text-base"
      >Yearly billing
      <span class="text-text-negative">(2 months free)</span></span
    >
  </form>
  <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
    @for (plan of plans; track plan.label) {
      <div
        class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <h3 class="text-xl font-bold">{{ plan.label }}</h3>
        <p class="text-pretty text-lg">
          {{ plan.description }}
        </p>
        <div class="flex items-end">
          <span class="text-xl font-bold md:text-2xl"
            >$
            {{
              (formGroup.controls.isYearlyCycle.value === true
                ? plan.yearlyPriceInCents / 100 / 12
                : plan.monthlyPriceInCents / 100
              ) | number: "1.0-2"
            }}</span
          >
          <span class="text-base text-gray-500">/ month</span>
        </div>
        <a
          [appearance]="plan.highlighted ? 'primary' : 'outline'"
          iconEnd="@tui.arrow-right"
          size="m"
          tuiAppearanceMode="checked"
          tuiButton
          type="button"
          [href]="consoleBaseUrl"
          target="_blank"
          data-umami-event="pricing-get-started-button"
        >
          Get started
        </a>
        <ul class="flex flex-col gap-2 text-base">
          @for (feature of plan.features; track $index) {
            <li class="flex items-center gap-2">
              <tui-icon class="text-primary" icon="@tui.check"></tui-icon>
              <span>{{ feature }}</span>
            </li>
          }
        </ul>
      </div>
    }
  </div>
  <div
    class="flex w-full flex-1 items-center justify-between gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
  >
    <div class="flex flex-col gap-4">
      <h3 class="text-xl font-bold">Custom</h3>
      <p class="text-pretty text-lg">
        Need a plan tailored to your specific requirements? Contact us for a
        custom solution for any business size.
      </p>
    </div>
    <tui-badged-content>
      <tui-icon
        appearance="accent"
        icon="@tui.dot"
        size="s"
        tuiBadge
        tuiSlot="top"
      />
      <button
        appearance="outline"
        size="l"
        tuiAppearanceMode="checked"
        tuiButton
        type="button"
        (click)="handleRequestCustomPlan()"
        data-umami-event="pricing-contact-custom-button"
      >
        Request quote
      </button>
    </tui-badged-content>
  </div>
  <div
    class="flex w-full flex-1 items-center justify-between gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
  >
    <div class="flex flex-col gap-4">
      <h3 class="text-xl font-bold">Enterprise</h3>
      <p class="text-pretty text-lg">
        Need SOC 2 compliance, audit logs, SSO, dedicated support, or SLAs?
        Contact us for a tailored solution.
      </p>
    </div>
    <button
      appearance="outline"
      size="l"
      tuiAppearanceMode="checked"
      tuiButton
      type="button"
      (click)="handleContactSales()"
      data-umami-event="pricing-contact-sales-button"
    >
      Contact sales
    </button>
  </div>
  <div
    class="flex w-full flex-1 items-center justify-between gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
  >
    <div class="flex flex-col gap-4">
      <h3 class="text-xl font-bold">Open Source</h3>
      <p class="text-pretty text-lg">
        Are you working on an open-source project? We have a free plan for you!
        Apply now to get started.
      </p>
    </div>
    <a
      appearance="outline"
      size="l"
      tuiAppearanceMode="checked"
      tuiButton
      type="button"
      href="https://forms.gle/3NLWT1Gt9shdGoUY7"
      target="_blank"
      data-umami-event="pricing-apply-open-source-button"
    >
      Apply now
    </a>
  </div>
</div>
